export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/hamburger-close.7fb0fb4b.svg","height":40,"width":40};